import { useCurrentWorkspaceInPrivateWorkspaceRoute } from '../../workspace/hooks'

const ENCRYPTED_OPTIONS = ['created-at', 'last-modified'] as const
const REGULAR_OPTIONS = ['name', ...ENCRYPTED_OPTIONS] as const

export type SortOptions = (typeof REGULAR_OPTIONS)[number]

export const useSortOptionsSettings = () => {
  const workspace = useCurrentWorkspaceInPrivateWorkspaceRoute()
  const { encryptionEnabled } = workspace.features

  return [...(encryptionEnabled ? ENCRYPTED_OPTIONS : REGULAR_OPTIONS)]
}
